<script lang="ts">
  const scrollToPrivacy = () => {
    document.getElementById("privacy_section").scrollIntoView();
  };
</script>

<svelte:head>
  <title>Text Archer</title> 
  <meta name="robots" content="index, follow">
<meta lang="english" content="text/html; charset=utf-8">
<meta name="language" content="English">
<meta name="revisit-after" content="30 days">
<meta name="author" content="Squaredojo">
<meta property="og:title" content={"Text Archer"}> 
</svelte:head>

<nav class="flex bg-purple-50">
  <a href="/#/textarcher" class="p-2 w-1/2 invisible md:visible">
    <img src="../images/textarcher/icon.png" width="42" alt="TextArcher logo" />
  </a>
  <h5 class="font-black text-center pt-3 w-full md:w-1/2 md:pt-3 md:text-xl">Available Now</h5>
  <!-- Menu -->
  <div class="text-right w-1/2 p-2">
    <button
      type="button"
      on:click={scrollToPrivacy}
      class="bg-green-900 text-gray-50 px-3 py-2 rounded-3xl text-md hover:bg-boyblue-900 hidden lg:inline">Privacy Policy</button
    >
  </div>
</nav>


<section id="hero"> 
  <div class="flex flex-col bg-gradient-to-r from-blue-500 to-purple-900 text-center items-center bg-repeat bg-opacity-100 bg-center">
    <img src="../images/textarcher/titlebackground.png" alt="TextArcher logo" />
    <h5 class="text-md p-5 font-black text-gray-500 md:text-4xl">
      PixelArt Scrabble, Shooting , Tetris and Trivia
    </h5>
  </div>

  <div class="text-lg p-2 mt-50 font-black text-center text-gray-700 bg-steel-200 md:text-3xl">
     Unlock Cute Characters
  </div>

    <div class="flex flex-wrap justify-center p-5 bg-steel-800">
      <img  src="../images/textarcher/catcharacter.png" alt="textarcher catcharacter" />
      <img src="../images/textarcher/foxcharacter.png" alt="textarcher foxcharacter" />
      <img src="../images/textarcher/pigcharacter.png" alt="textarcher pigcharacter" />
      <img src="../images/textarcher/racooncharacter.png" alt="textarcher racooncharacter" />
    </div>

   
    <!---<iframe
            class="w-full h-[300px] sm:h-[450px] md:h-[600px] lg:h-[450px] xl:h-[600px]"
            src="">
    </iframe>-->
  </section>

  <section class="flex flex-wrap justify-center bg-blue-400 text-center p-10 md:w-fit h-full"> 
    <iframe  class="md:w-1/2 md:h-150"  src="https://www.youtube.com/embed/L6wn5dUjVZ4?si=LJ5bX5iGbT9wJ_NL" 
    title="TextArcher Play Video Playe" frameborder="0" 
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope;
    picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
  </section>


  <div class="flex flex-wrap justify-center bg-steel-400 text-center pt-10 md:gap-x-14">
    <img src="../../images/available_app_store.png"
      alt="textarcher available now available at apple app store"
      class="p-4"/>

    <img src="../../images/available_play_store.png"
      alt="textarcher available now apple at google play store"
      class="p-4" />
  </div>


<div class="  bg-steel-400 text-center mb-300 px-30">
  <div class="p-2">
   
    <br />
  </div>
  <div class="text-lg p-2 font-black text-center text-gray-700 bg-steel-200 md:text-3xl" id="terms_section">
    Terms and Conditions
  </div>
  <div class="w-full px-4 px-2  m-2 mx-auto text-left md:border md:w-1/2" >
   <p>
    Please read these terms and conditions ("terms and conditions", "terms") carefully
    before using Text Archer mobile game (“app”, "service") operated by Deepindera Dhanda ("Squerdojo" "I" "us", 'we", "our").Last updated 20 May 2024
    </p>  
     <p><strong>Conditions of use</strong></p> <p>
      By using Text Archer game, you certify that you have read and reviewed this Agreement and that
      you agree to comply with its terms. If you do not want to be bound by the terms of this
      Agreement, you are advised to stop using the app accordingly. We only
      grants use and access of this app, its products, and its services to those who have
      accepted its terms.
    </p> 
     <p><strong>Intellectual property</strong></p> <p>
      You agree that all materials, and assets provided on this game are the
      property of Squaredojo including all copyrights, trade secrets, trademarks, patents, and
      other intellectual property. You also agree that you will not reproduce or redistribute the
      our intellectual property in any way, including electronic, digital, or new
      trademark registrations
    </p> 
    <p><strong>Limitation on liability</strong></p> <p>
       Squaredojo is not liable for any damages that may occur to you or your device or property as a result of your
use of Text Archer game.
    </p> <p><strong>Contact Us</strong></p> <p>
      We reserve the right to edit, modify, and change this Agreement at any
time.  This
Agreement is an understanding between Squaredojo and you (you the end user or player) the person, and this
supersedes and replaces all prior agreements regarding the use of this app
      If you have any questions or suggestions about
      my Privacy Policy, do not hesitate to contact
      me at deepindera@squaredojo.com
    </p>
  </div>
  <div class="text-lg p-2 font-black text-center text-gray-700 bg-steel-200 md:text-3xl" id="privacy_section">
    Privacy Policy
  </div>
  <br>
  <div class="w-full md:w-1/2 px-4 px-2 mx-auto text-left md:border" > 
   <p>
      This page is used to inform visitors regarding
      Text Archer game policies with the collection, use, and
      disclosure of any Personal Information if anyone decided to use or
      install or play the game. Last updated 20 May 2024
    </p>  
     <p><strong>Information Collection and Use</strong></p> <p>
      We do not collect any private information of the user. The game does not use any third party services google analytics that may collect.
      The only data that may be used by third party service is during the IAP (In App purchase) process but again that is not 
      collected or controlled by Text Archer.
    </p> 
     <p><strong>Changes to This Privacy Policy</strong></p> <p>
      I may update our Privacy Policy from
      time to time. Thus, you are advised to review this page
      periodically for any changes. I will
      notify you of any changes by posting the new Privacy Policy
      on this page. These changes are effective immediately after
      they are posted on this page.
    </p> <p><strong>Contact Us</strong></p> <p>
      If you have any questions or suggestions about
      my Privacy Policy, do not hesitate to contact
      me at deepindera@squaredojo.com
    </p>
  </div> <br>
</div>
<div class="bg-repeat  h-20 " 
         style="background-image: url('../images/textarcher/widewall.png');" >

</div>
<br>
  <div class="container mx-auto text-center text-gray-700 pb-10 opacity-90">
    2024 | Made by <a href=".">SquareDojo</a>
  </div>

